export default __webpack_public_path__ + "static/media/print-label-fourth-position.e644b92c.svg";